<template>
<div>
    <site-header></site-header>
    <div ref="form-ref" :key="'form'" class="c-t-form">
        <div class="c-t-form__header">
            <page-header class="c-o-page-header--centered" v-bind="pageHeader"></page-header>

            <!-- <progress-bar v-if="categoryLoaded" ref="progress-bar"></progress-bar> -->
        </div>

        <div class="c-t-form__main" :class="{'c-t-form__main--only-child': !showSidebar && categoryLoaded, 'c-t-form__main--step-zero': !showSidebar && !categoryLoaded}">

            <transition name="o-transition--fade" mode="out-in">
                <keep-alive>
                    <loader class="c-o-loader--large" key="rf-loading" v-if="isLoading"></loader>

                    <error-state key="rf-error-1" v-if="error && error === 'not-sent'" v-bind="errorMessageNotSent"></error-state>
                    <error-state key="rf-error-2" v-else-if="error || errorFilters" v-bind="errorMessageNotFetched"></error-state>

                    <success-state key="formSent" v-if="createdRequest" class="c-m-success-state--large" v-bind="successMessage"></success-state>

                    <drilldown class="c-a-drilldown--vertically-compact" key="rf-select" v-if="!isLoading && !error && !categoryLoaded && !createdRequest" :items="categories" :label="'Välj en kategori för att komma igång'" :placeholder="'Beskriv eller välj en kategori'"
                      @input="setCategory"></drilldown>

                    <organism-request-form-main key="rf-form" v-if="!isLoading && !error && categoryLoaded && !createdRequest" @resetForm="resetForm" @requestDone="scrollToFormTop"></organism-request-form-main>
                </keep-alive>
            </transition>
        </div>

        <div v-if="showSidebar" class="c-t-form__sidebar">
            <!-- Här kör vi instruktioner/tips, direktförfrågningar, merförsäljning, dylikt -->
            <organism-request-form-sidebar></organism-request-form-sidebar>
        </div>
    </div>
    <site-footer></site-footer>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex';
import Vue from 'vue';

import {
    FETCH_FORM_BY_ID,
    GET_FORM,
    IS_LOADING,
    GET_ERROR,
    SET_FORM_STEP,
    RESET_ERROR,
    RESET_FORM_DATA,
    GET_CREATED_REQUEST
} from '../store/store-models/request-form-model.js';

import {
    GET_COMPANIES
} from '../store/store-models/queued-companies-model.js';

import {
    GET_CATEGORIES,
    GET_ERROR as GET_ERROR_FILTERS
} from '../store/store-models/filters-model';

import {
    GET_STRINGS
} from '../store/store-models/meta-model';

import {
    IS_CUSTOMER
} from '../store/store-models/authentication-model.js';
import {
    FETCH_CUSTOMER_BY_ID
} from '../store/store-models/my-pages-customer-model.js';

import Drilldown from './components/atoms/form/AtomDrilldownCategories.vue'
import SiteHeader from './components/organisms/OrganismSiteHeader.vue';
import SiteFooter from './components/organisms/OrganismSiteFooter.vue';
import PageHeader from './components/organisms/OrganismPageHeader.vue';
import SuccessState from './components/molecules/MoleculeSuccessState.vue';
import Loader from './components/molecules/MoleculeLoader.vue';
import ErrorState from './components/molecules/MoleculeErrorState.vue';
import ProgressBar from './components/molecules/MoleculeProgressBar.vue';
import OrganismRequestFormMain from './components/organisms/OrganismRequestFormMain.vue';
import OrganismRequestFormSidebar from './components/organisms/OrganismRequestFormSidebar.vue';

export default {
    asyncData({
        store,
        route
    }) {
        let id = route.params.id ? route.params.id : null;
        return store.dispatch(FETCH_FORM_BY_ID, id);
    },
    components: {
        Drilldown,
        SiteHeader,
        SiteFooter,
        ProgressBar,
        PageHeader,
        SuccessState,
        Loader,
        ErrorState,
        OrganismRequestFormMain,
        OrganismRequestFormSidebar
    },
    data() {
        return {
            id: this.$route.params.id ? this.$route.params.id : null,
        }
    },
    computed: {
        ...mapGetters({
            categories: GET_CATEGORIES,
            form: GET_FORM,
            error: GET_ERROR,
            errorFilters: GET_ERROR_FILTERS,
            isLoading: IS_LOADING,
            createdRequest: GET_CREATED_REQUEST,
            queuedCompanies: GET_COMPANIES,
            strings: GET_STRINGS,
            isCustomer: IS_CUSTOMER,
        }),
        categoryLoaded: function() {
            return this.form.data.steps ? true : false
        },
        pageHeader: function() {

            const obj = {
                body: this.strings['request-form-page-header-body']
            };

            if (this.form.data.image) {
                obj.image = this.form.data.image;
            }

            if (this.form.data.title) {
                obj.title = this.form.data.title
            } else if (this.form.data.subCategory) {
                obj.title = `${this.form.data.subCategory} ${this.strings['request-form-page-header-title-subtitle']}`
            } else {
                obj.title = `Hitta hantverkare ${this.strings['request-form-page-header-title-subtitle']}`
            }

            if (this.queuedCompanies && this.queuedCompanies.length > 0) {
                if (this.strings['request-direct-form-page-header-body']) {
                    obj.body = this.strings['request-direct-form-page-header-body']
                }
            }

            return obj;
        },
        successMessage: function() {
            return {
                heading: this.strings['request-form-success-message-title'],
                body: this.strings['request-form-success-message-body'],
                button: {
                    label: 'Se din förfrågan',
                    icon: 'arrow_forward',
                    classes: 'c-a-button--theme-primary c-a-button--icon-right ',
                    to: this.createdRequest ? `/forfragan/${this.createdRequest.id}` : null
                }
            }
        },
        instructions: function() {
            return {
                heading: this.strings['request-form-queue-instructions-title'],
                body: this.strings['request-form-queue-instructions-body']
            }
        },
        errorMessageNotSent: function() {
            return {
                heading: this.strings['request-form-error-message-not-sent-title'],
                body: this.strings['request-form-error-message-not-sent-body'],
                button: {
                    label: 'Gå tillbaka',
                    icon: 'arrow_back',
                    classes: 'c-a-button--theme-secondary ',
                    function: this.resetError
                }
            }
        },
        errorMessageNotFetched: function() {
            return {
                heading: this.strings['request-form-error-message-not-fetched-title'],
                body: this.strings['request-form-error-message-not-fetched-body'],
                button: {
                    label: 'Försök igen',
                    icon: 'sync',
                    classes: '',
                    // This is an external link as it will force refresh the app and hopefully reset potential problems
                    url: '/skapa-forfragan/'
                }
            }
        },
        showSidebar: function() {
            return this.queuedCompanies.length > 0 ? true : false
        }
    },
    methods: {
        ...mapActions({
            setFormStep: SET_FORM_STEP,
            resetError: RESET_ERROR,
            fetchCustomerById: FETCH_CUSTOMER_BY_ID
        }),
        scrollToFormTop() {
            this.$refs['form-ref'].scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest'
            });
        },
        async setCategory(value) {
            this.$router.push({
                name: 'Skapa förfrågan',
                params: {
                    id: value.Id
                }
            });
        },
        async resetForm() {
            await this.$store.dispatch(RESET_FORM);
            this.$router.push({
                name: 'Skapa förfrågan'
            });
        }
    },
    async beforeRouteUpdate(to, from, next) {
        let id = to.params.id ? to.params.id : null;
        await this.$store.dispatch(FETCH_FORM_BY_ID, id);
        next();
    },
    metaData() {
        const title = this.pageHeader.title ? this.pageHeader.title : ''
        return {
            title: this.pageHeader.title,
            meta: [{
                vmid: 'description',
                name: 'description',
                content: `${title} Här kan du göra egna förfrågningar.`
            }],
            link: [
                {rel: 'canonical', href: `${process.env.SITE_BASE_URL}${this.$route.path}`}
            ],
            }
    },
    async created() {
        if (this.isCustomer) {
            await this.fetchCustomerById();
        }
        
        const queryParams = this.$route.query;

        if (queryParams.extId) {
            externalId = this.$route.query.extId
        } else if (queryParams.extid) {
            externalId = this.$route.query.extid
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/RequestForm.vue